import { render, staticRenderFns } from "./touchBalance.vue?vue&type=template&id=db614b9a&scoped=true&"
import script from "./touchBalance.vue?vue&type=script&lang=js&"
export * from "./touchBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db614b9a",
  null
  
)

export default component.exports